
import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AppContextService } from '@drc-eca/eca-components-lib';
import { EcaApiGatewayService } from './../api-gateway/api-gateway.service';

@Injectable({
  providedIn: 'root'
})
export class EcaSecurityUsersService {
  private http = inject(HttpClient);
  private apiGatewayService = inject(EcaApiGatewayService);
  private appContextService = inject(AppContextService);

  private _securityServiceUrl: string;
  mockUser: object;
  getThrow: boolean;

  private securityServiceUrl() {
    if (this._securityServiceUrl) {
      return this._securityServiceUrl;
    }

    return (this._securityServiceUrl = this.apiGatewayService.lookup('eca-security-service'));
  }

  create(user: any): Observable<any> {
    return this.appContextService.selectedProductCode$.pipe(
      switchMap(productCode => {
        return this.http.post(`${this.securityServiceUrl()}/user`, {...user, clientCode: productCode});
      })
    );
  }

  update(user: any): Observable<any> {
    return this.http.put(`${this.securityServiceUrl()}/user/${user.userId}`, user);
  }

  get(userId: string): Observable<any> {
    return this.http.get(`${this.securityServiceUrl()}/user/${userId}`);
  }

  getByUsername(username: string): Observable<any> {
    let params = new HttpParams();
    params = params.set('username', username);
    return this.http.get(`${this.securityServiceUrl()}/user`, { params: params }).pipe(map((res: any[]) => (res.length ? res[0] : null)));
  }

  createAcl(userId: string, acl: any, deny?: boolean): Observable<any>;
  createAcl(userId: string, acl: string, deny?: boolean): Observable<any> {
    let body;

    if (typeof acl === 'string') {
      if (deny === undefined) {
        deny = false;
      }
      body = { acls: [{ acl: acl, deny: deny }] };
    } else {
      body = { acls: acl };
    }
    return this.http.put(`${this.securityServiceUrl()}/user/${userId}/acls`, body, { responseType: 'text' });
  }

  createWithAcl(user: any, acl?: string): Observable<any> {
    let userId;
    return this.create(user).pipe(
      switchMap(_user => {
        userId = _user['userId'];
        if (acl) {
          return this.createAcl(userId, acl);
        } else {
          return of(_user);
        }
      }),
      switchMap(() => this.get(userId)), );
  }

  removeAcl(userId: string, acl: string[]): Observable<any> {
    const body = { acls: acl };
    return this.http.request('DELETE', `${this.securityServiceUrl()}/user/${userId}/acls`, { body: body, responseType: 'text' });
  }
}
